import { render, staticRenderFns } from "./loading_icon.vue?vue&type=template&id=2340e698"
import script from "./loading_icon.vue?vue&type=script&lang=js"
export * from "./loading_icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports